import React from "react";
import { Flex, Button, HStack } from "@chakra-ui/react";
import { Hide } from "../common/Hide";
import { Break } from "../styled/Break";

export function BackAndNext({ isBackHidden, onClickBack, onClickNext, backBackground, nextBackground }: Props) {
  return (
    <Flex>
      <Hide hide={isBackHidden}>
        <Button onClick={onClickBack} color="black" mr="1vw">
          Back
        </Button>
      </Hide>
      <Button onClick={onClickNext} background={backBackground} color="white" _hover={{}}>
        Next
      </Button>
      <Break height="5vh" />
    </Flex>
  );
}

interface Props {
  isBackHidden: boolean;
  onClickBack: () => void;
  onClickNext: () => void;
  backBackground: string;
  nextBackground: string;
}
